import usePermissions from '@/hooks/usePermissions';

import { OrganizationStatus, UserPermissions } from 'types';

import { useAuth } from './authProvider';
import { isPalmettoFinanceUser } from './RequirePalmettoFinanceUser';

export const useIsOrgReadOnly = () => {
  const { claims } = useAuth();
  const userPermissions = usePermissions();
  const isLightReachAdmin = isPalmettoFinanceUser(claims) && userPermissions.includes(UserPermissions.admin);
  const allowsByOrgStatus =
    claims?.orgStatus !== OrganizationStatus.readOnly && claims?.rootOrgStatus !== OrganizationStatus.readOnly;
  const allows = isLightReachAdmin ? true : allowsByOrgStatus;
  return allows;
};
